import { LocationIcon, MobileIcon, EmailIcon } from 'shared-widget-components/src/components/Icons';
import { ContactWidgetState } from '../../models/ContactWidgetState';

export const ContactInfo = ({ props }: { props: ContactWidgetState }) => {
  const address = `${props?.zipCode} ${props?.city}, ${props?.address}`;

  return (
    <>
      <h1 className='font-body font-bold text-[16px] text-black min-h-[30px] mb-1' style={{ color: props.textColor }}>
        {props.title}
      </h1>
      <div className='flex items-center min-h-[30px]'>
        <p className='w-[20px] h-[20px]' style={{ color: props.iconColor }}>
          <LocationIcon />
        </p>
        <p className={`font-body ml-2 text-[14px] text-black font-bold w-3/4`} style={{ color: props.textColor }}>
          {address}
        </p>
      </div>
      <div className='flex items-center min-h-[30px]'>
        <p className='w-[20px] h-[20px]' style={{ color: props.iconColor }}>
          <MobileIcon />
        </p>
        <p className={`font-body ml-2 text-[14px] text-black font-bold w-3/4`} style={{ color: props.textColor }}>
          {props.phone}
        </p>
      </div>
      <div className='flex items-center min-h-[30px]'>
        <p className='w-[20px] h-[20px]' style={{ color: props.iconColor }}>
          <EmailIcon />
        </p>
        <p className={`font-body ml-2 text-[14px] text-black font-bold w-3/4`} style={{ color: props.textColor }}>
          {props.email}
        </p>
      </div>
    </>
  );
};
